export default "__VITE_ASSET__CP5bmXCA__"